import React from 'react';
import GeneralTable from './GeneralTable';

const RANK_CONFIG = [
  { match: /firefighter|\bff\b/i, prefix: 'FF', label: 'Firefighter' },
  { match: /engineer|\beng\b/i, prefix: 'ENG', label: 'Engineer' },
  { match: /captain|\bcap\b/i, prefix: 'CAP', label: 'Captain' },
  { match: /battalion chief|\bbc\b/i, prefix: 'BC', label: 'Battalion Chief' }
];

function rankConfig(rank) {
  const text = String(rank || '').trim();
  return RANK_CONFIG.find(item => item.match.test(text)) || null;
}

export default function RankStaffingCalendar({ general, rank }) {
  const config = rankConfig(rank);
  const sourceHeaders = general?.headers || [];
  const rows = general?.rows || [];

  if (!config || !rows.length) return null;

  const source = {
    vacancy: `${config.prefix} Vac`,
    mcb: `${config.prefix} MCB`,
    available: `${config.prefix} Avail`
  };

  const headers = ['Date'];
  if (sourceHeaders.includes(source.vacancy)) headers.push('Vacancies');
  if (sourceHeaders.includes(source.mcb)) headers.push('MCB');
  if (sourceHeaders.includes(source.available)) headers.push('Available');

  if (headers.length === 1) return null;

  const rankRows = rows.map(row => {
    const next = { Date: row.Date };
    if (headers.includes('Vacancies')) next.Vacancies = row[source.vacancy];
    if (headers.includes('MCB')) next.MCB = row[source.mcb];
    if (headers.includes('Available')) next.Available = row[source.available];
    return next;
  });

  return (
    <div className="pub-rank-calendar">
      <div className="pub-rank-calendar-head">
        <strong>7-Day {config.label} Staffing</strong>
        <span>General staffing outlook for this member&apos;s rank.</span>
      </div>
      <GeneralTable general={{ headers, rows: rankRows }} compact />
      <div className="pub-note pub-rank-calendar-note">
        This is the general staffing baseline. The individual deployment effect is shown above.
      </div>
    </div>
  );
}
